<template>
  <section>
    <TableListing :items="itemsColored" :fields="fieldsAll" :showPaginationRow="true" :pagination.sync="pagination" :options.sync="tableOptions">
      <!-- <template v-slot:cell(amount)="data">
        <span>$ {{ parseFloat(data.item.amount).toFixed(2) }}</span>
      </template> -->
      <template v-slot:cell(tplFacilityId)="data">
        <span>{{tplFacilities.find(a => a.id == data.item.tplFacilityId) ? tplFacilities.find(a => a.id == data.item.tplFacilityId).name : ''}}</span>
      </template>
      <template v-slot:cell(tplCustomerId)="data">
        <span>{{tplCustomers.find(a => a.id == data.item.tplCustomerId) ? tplCustomers.find(a => a.id == data.item.tplCustomerId).companyName : '' }}</span>
      </template>
    </TableListing>
  </section>
</template>

<script>
import { TableListing } from '@/views/components/custom';
import { mapGetters } from 'vuex';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'OrderedStorefrontItemsReport-view',
  components: {
    TableListing: TableListing
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    itemsColored: {
      get() {
        let itms = this.items;
        itms.forEach((itm) => {
            itm['_cellVariants'] = { quantityIn_Total: 'success', quantityOut_Total: 'danger', sku: 'warning' };
        });
        return itms;
      },
      set(val) {
        this.items = val;
      }
    },
    tplFacilities: {
      get() {
        let myItems = this.$store.getters.getMyTPL.facilities;
        return myItems;
      },
      set(val) {
        //his.$store.dispatch('setFacilitiesList', val);
      }
    },
    tplCustomers: {
      get() {
        let myItems = this.$store.getters.getMyTPL.customers;
        return myItems;
      },
      set(val) {
        //his.$store.dispatch('setFacilitiesList', val);
      }
    },
  },
  mounted() {
    this.$store.dispatch('fetchMyTPLData');
    this.tableOptions.totalRows = this.items.length;
  },
  data() {
    return {
      pagination: {
        sortBy: '',
        sortDesc: false,
        perPage: 20,
        page: 1
      },
      tableOptions: {
        totalRows: 20,
        loadedAll: true
      },
      fieldsAll: [
        { key: 'tplFacilityId', label: 'Warehouse', sortable: true },
        { key: 'tplCustomerId', label: 'Client', sortable: true },
        { key: 'sku', label: 'Item', sortable: true },

        { key: 'quantityOut_StorefrontOrder', label: 'Storefronts Out', sortable: true },
        { key: 'quantityOut_WorkOrder', label: 'Work Orders Out', sortable: true },
        { key: 'quantityOut_ManualOrder', label: 'Small Parcel & Bulk Out ', sortable: true },
        { key: 'quantityOut_WarehouseShipment', label: 'WTs Out ', sortable: true },
        { key: 'quantityOut_DirectInventoryUpdate', label: 'Inv. Updates Out ', sortable: true },
        { key: 'quantityOut_TPLAdjustment', label: 'WMS Adjust. Out ', sortable: true },
        { key: 'quantityOut_Unknown', label: 'Unknown Out ', sortable: true },
        { key: 'quantityOut_Total', label: 'Qty Out Total', sortable: true },

        { key: 'quantityIn_TPLAdjustment', label: 'Extensiv Adjust. In', sortable: true },
        { key: 'quantityIn_IncomingWarehouseShipment', label: 'ASN & WT In', sortable: true },
        { key: 'quantityIn_IncomingReturn', label: 'Returns In ', sortable: true },
        { key: 'quantityIn_IncomingDirectInventoryUpdate', label: 'Inv. Updates In', sortable: true },
        { key: 'quantityIn_Unknown', label: 'Unknown In', sortable: true },
        { key: 'quantityIn_Total', label: 'Qty In Total', sortable: true },
      ],
    }
  }
}
</script>

<style>

</style>
